import {Vue} from "ui.vue";

import BasketItems from "./components/base.vue";

Vue.component("CitrusBasketItems", BasketItems);
